import KeyboardEventsHandler from './KeyboardEventsHandler'

export default async function(ctx, inject) {
  const keyboardEvents = KeyboardEventsHandler.getInstance()

  ctx.$keyboardEvents = keyboardEvents
  inject('keyboardEvents', keyboardEvents)
}
